(() => {
  const THRESHOLD = 5000;
  const EMPTY_MESSAGE = 'Singapore Local Stock • Ships Next Working Day • Free SG Shipping Over S$50';

  const money = (cents) =>
    new Intl.NumberFormat('en-SG', { style: 'currency', currency: 'SGD' }).format(Math.max(0, cents) / 100);

  function messageFor(cart) {
    if (!cart || cart.item_count === 0) return EMPTY_MESSAGE;
    const remaining = THRESHOLD - cart.total_price;
    if (remaining <= 0) return "✓ You've unlocked FREE SG Shipping!";
    if (remaining <= 1000) return `Only ${money(remaining)} more for FREE SG Shipping`;
    return `Add ${money(remaining)} more for FREE SG Shipping`;
  }

  function updateAll(cart) {
    const message = messageFor(cart);
    document.querySelectorAll('[data-skit-free-shipping-message], [data-skit-shipping-announcement]').forEach((el) => {
      el.textContent = message;
    });
    document.querySelectorAll('[data-skit-free-shipping-fill]').forEach((el) => {
      const pct = !cart || cart.item_count === 0 ? 0 : Math.min(100, (cart.total_price / THRESHOLD) * 100);
      el.style.width = pct + '%';
    });
    document.querySelectorAll('[data-skit-free-shipping]').forEach((el) => {
      el.dataset.cartTotal = cart ? cart.total_price : 0;
    });
  }

  let refreshTimer;
  async function refresh(delay = 0) {
    window.clearTimeout(refreshTimer);
    refreshTimer = window.setTimeout(async () => {
      try {
        const url = (window.routes?.cart_url || '/cart') + '.js?t=' + Date.now();
        const response = await fetch(url, {
          headers: { Accept: 'application/json' },
          credentials: 'same-origin',
          cache: 'no-store'
        });
        if (!response.ok) return;
        updateAll(await response.json());
      } catch (e) {
        // Keep the most recent server-rendered state if refresh is unavailable.
      }
    }, delay);
  }

  document.addEventListener('DOMContentLoaded', () => refresh());

  if (window.PUB_SUB_EVENTS && window.PUB_SUB_EVENTS.cartUpdate && typeof window.subscribe === 'function') {
    window.subscribe(window.PUB_SUB_EVENTS.cartUpdate, () => refresh(100));
  }

  document.addEventListener('change', (event) => {
    if (event.target.closest('cart-items, cart-drawer-items')) refresh(650);
  });

  document.addEventListener('click', (event) => {
    if (event.target.closest('cart-remove-button, quantity-input')) refresh(800);
  });

  const originalFetch = window.fetch;
  window.fetch = async function (...args) {
    const response = await originalFetch.apply(this, args);
    const requestUrl = typeof args[0] === 'string' ? args[0] : (args[0] && args[0].url) || '';
    if (/\/cart\/(add|change|update)(\.js)?(?:\?|$)/.test(requestUrl)) {
      refresh(150);
    }
    return response;
  };
})();
